
(function () {
    $(document).ready(function () { 
        $(".equipment-search-spinner").hide();
        $(".ebback").click(function () {
            $(".ebback").css("display", "none");
            $("#equipmentBuilder").css("display", "block");
            $("#equipment").empty();
            $("#equipment").css("display", "none");
        });
        $("#searchText").keydown(function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                $(".eqsearch").trigger('click');
            }
        });
        $(".eqsearch").on('click', function () {
            if ($(".equipment-search-spinner").length > 0) {
                var exp = $(".equipment-search-spinner");
                var child = exp.parent().siblings().find(".search-box");
                exp.insertAfter(child);
            }
            $(".equipment-search-spinner").show();
            $("#equipmentBuilder").empty();
            var ebName = $("#searchText").val();
            var itemId = $('#endorsementItemId').val();
            var language = $('#endorsementlanguage').val();
            $.ajax({
                url: "/api/EquipmentBuilder/EquipmentBuilderByName?name=" + ebName + "&itemId=" + itemId + "&language=" + language,
                type: "GET",
                dataType: "json",
                traditional: !0,
                contentType: "application/json; charset=utf-8",
                success: function (data) {
                    if (data.length > 0) {
                        $(".equipment-search-spinner").hide();
                        // 19 new components accessibility 1.19 - Status msg
                        $("#equipmentBuilder").attr({
                            "role": "status",
                            "aria-live": "polite",
                            "aria-atomic": "true"
                        });
                        var statusMsg = $("#equipmentBuilder").attr("data-eqb-message");
                        var spanEle = '<span class="sr-only">' + statusMsg + ' ' + data.length + '</span></br>';
                        var ebTitle = $("#ListText1").val() + "</br></br>";
                        for (var ebList = ebTitle, n = 0; n < data.length; n++) ebList = ebList + '<a href="#" onclick="return false;" data-url="' + data[n].Url + '" data-name="' + data[n].Name + '"class="equipmentengine">' + data[n].Name + "</a></br/>";
                        $("#equipmentBuilder").html(sanitizeHtmlStrings(ebList, {
                            whiteList: {
                                a: ["class", "href", "data-url", "data-name", "onclick"],
                                br: []
                            }
                        }));
                        // 19 new components accessibility 1.19 - Status msg
                        $("#equipmentBuilder").prepend(sanitizeHtmlStrings(spanEle));
                    } else {
                        $(".equipment-search-spinner").hide();
                        $("#equipmentBuilder").attr("aria-live", "polite");
                        var errormessage = $("#ErrorMessage").val();
                        $("#equipmentBuilder").html(sanitizeHtmlStrings(errormessage));
                    }
                },
                error: function (request, status, error) {
                    $(".equipment-search-spinner").hide();
                }
            });
        });

        $(document).on("click", "a.equipmentengine", function () {
            $(".equipment-search-spinner").show();
            $("#equipmentBuilder").css("display", "none");
            var eqURL = $(this).attr("data-url");
            var eaName = $(this).attr("data-name");
            var itemId = $('#endorsementItemId').val();
            var language = $('#endorsementlanguage').val();
            eqURL = eqURL + "&itemId=" + itemId + "&language=" + language;
            $.ajax({
                url: eqURL,
                type: "GET",
                dataType: "json",
                traditional: !0,
                contentType: "application/json; charset=utf-8",
                success: function (data) {
                    if (data.length > 0) {
                        // 19 new components accessibility 1.19 - Status msg
                        $(".equipment-search-spinner").hide();
                        $("#equipment").attr({
                            "role": "status",
                            "aria-live": "polite",
                            "aria-atomic": "true"
                        });
                        var statusMsg = $("#equipment").attr("data-eq-message");
                        var spanEle = '<span class="sr-only">' + statusMsg + ' ' + data.length + '</span></br>';

                        var eqTitle = $("#ListText2").val() + "</br></br>";
                        eqTitle = eqTitle.replace("{0}", eaName);
                        for (var eqList = eqTitle, n = 0; n < data.length; n++) eqList = eqList + '<a href="' + data[n].URL + '">' + data[n].Name + "</a></br/>";
                        $("#equipment").html(sanitizeHtmlStrings(eqList, {
                            whiteList: {
                                a: ["class", "href"],
                                br: []
                            }
                        }));
                        // 19 new components accessibility 1.19 - Status msg
                        $("#equipment").prepend(sanitizeHtmlStrings(spanEle));
                        // Bug 83643: Mobil Issue 1.19 -The focus line for the link (back) is large in size
                        $(".ebback").css("display", "inline-block");
                        $("#equipment").css("display", "block");
                    } else {
                        $(".equipment-search-spinner").hide();
                        // 19 new components accessibility 1.19 - Status msg
                        $("#equipment").attr("aria-live", "polite");

                        var errormessage = $("#ErrorMessage").val();
                        $("#equipment").html(sanitizeHtmlStrings(errormessage));
                        // Bug 83643: Mobil Issue 1.19 -The focus line for the link (back) is large in size
                        $(".ebback").css("display", "inline-block");
                    }
                }
            });
        });
    });
}(window.jQuery));